module.exports = __webpack_public_path__ + "assets/bgPhoneMobile.cb2dc5ed27c89d9e23a61409ee1ff3b3227c4fcc7f3e6b9bb767554abed37017.jpg";